import { SET_BANGO, CLEAR_BANGO, SET_INITIAL_SHEER_STEP, SET_REDIRECT_URL } from '../Types';

const initialState = {
  bango: {
    subscriptionId: '',
    redirectUrl: '',
    productId: '',
  },
  step: '',
};

export const integrations = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_BANGO:
      return { ...state, bango: payload };
    case CLEAR_BANGO:
      return { ...state, bango: initialState.bango };
    case SET_INITIAL_SHEER_STEP:
      return { ...state, step: payload };
    case SET_REDIRECT_URL:
      return { ...state, bango: { ...state.bango, redirectUrl: payload } };
    default:
      return state;
  }
};
